<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex align-items-center justify-content-between">
          <h2>{{ $static('category.title', 'Категорії') }}</h2>
          <button class="default-btn btn-with-icon btn-accent" @click="addNew">
            <span class="text">{{ $static('category.add', 'Додати категорію') }}</span>
            <span class="icon icon-add"></span>
          </button>
        </div>

        <div class="default-cards-list " v-if="category">
          <div class="default-cards-top">
            <div class="name name-category">{{ $static('category.name', 'Назва категорії') }}</div>
            <div class="name name-available">{{ $static('category.status', 'Статус') }}</div>
            <div class="name name-hidden-category">{{ $static('category.hidd', 'Приховати категорію') }}</div>
            <div class="name name-actions">{{ $static('category.actions', 'Виконати дії') }}</div>
          </div>
          <CategoriesRow v-for="(item, index) in list" :key="index" :item="item"
            @open="event => openEditor(item, event)" @remove="event => removeItem(item)" @down="swap(index, index + 1)"
            @up="swap(index, index - 1)" />
        </div>

        <!--        <button @click="openEditor">editor</button>-->
      </div>
    </div>

    <Teleport to="body">
      <!-- EDITOR WRAPPER-->
      <div class="overlay-editor item-editor">
        <div class="overlay-editor-wrapper" v-if="selected">
          <div class="panel-top">

            <div class="lang-selector-holder d-flex align-items-center">
              <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:')
                }}</label>
              <LangSelector v-model="lang" />
            </div>

            <a href="javascript:void(0);" class="back_trigger" @click="cancel">
              <span class="icon icon-cross"></span>
            </a>
          </div>
          <div class="panel-middle">
            <h3 class="panel-top-name">{{ $static('category.editor', 'Редагування категорії') }}</h3>
            <div class="custom-label" style="color:#565656; margin-top: 25px; font-style: italic">
              {{ $static('category.t222',
                'Рекомендований розмір 1200 x 500 px. Крім того, радимо оптимізувати зображення') }}</div>
            <div class="files-uploader default-files-uploader" style="margin-bottom:20px;">
              <div class="files-uploader-holder" v-if="!selected.image" @click="openFileManager">
                <span class="icon icon-cloud-upload"></span>
                <p>{{ $static('multisend-i.up1', 'Завантажте свої зображення сюди') }}</p>
                <span>{{ $static('multisend-i.up2', 'Зображення повинні мати розширення .png або .jpg') }}</span>
              </div>
              <div class="uploader-previews" @click="openFileManager" v-else>
                <div class="image bg" :style="{ backgroundImage: $filters.backgroundImage(selected.image) }">
                  <a href="#" class="btn-icon btn-remove btn-small" @click.prevent.stop="delImage">
                    <span class="icon icon-trash-filled"></span>
                  </a>
                </div>
              </div>
              <div class="image image-placeholder" v-if="selected.image" @click="openFileManager">
                <div class="text">1200 x 500</div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="form-group">
                  <div class="custom-label">{{ $static('category.name', 'Назва категорії') }}</div>
                  <template v-if="basicLang">
                    <input type="text" class="form-control custom-input w-40" v-model="selected.name">
                  </template>
                  <template v-else>
                    <input type="text" class="form-control custom-input w-40" v-model="translate.name"
                      :placeholder="name" @update:modelValue="e => setTranslate('name', e)">
                  </template>
                  <!--                  <input type="text" class="form-control custom-input" v-model="selected.name">-->
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col">
                <div class="option-box mt-0 mb-2">
                  <div class="option-line" style="display: block">
                    <div class="option-name mb-1">{{ $static('category.hidd', 'Приховати категорію') }}</div>
                    <div class="toggle-holder">
                      <div class="toggler r">
                        <input type="checkbox" class="toggle-check" v-model="selected.disabled" :true-value="1"
                          :false-value="0">
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <!--sizes-->
                <div class="size-panel mb-1" v-for="(option, index) in optionsTags" :key="index">
                  <div class="custom-label">{{ this.$dynamic(option, option.option,
                    'option') }}:</div>
                  <div class="size-checkbox-group">
                    <!--size checkbox-->
                    <div class="option-checkbox" v-for="(item, index) in option.list" :key="index">
                      <input :id="item.option_id + index" type="checkbox"
                        @change="selectOption(item.option_id, item.id)"
                        :checked="selectedOption(item.option_id, item.id) > -1" :value="item.id"
                        :name="option.option_id">

                      <label :for="item.option_id + index">{{ item.name }}</label>
                    </div>
                    <!--end size checkbox-->
                  </div>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="form-group">
                  <div class="custom-label">URL</div>
                  <input type="text" class="form-control custom-input" v-model="selected.info.url"
                    :placeholder="urlTranslite">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <div class="custom-label">{{ $static('ceo.t1', 'Мета-тег Title') }}</div>
                  <input type="text" class="form-control custom-input" v-model="selected.info.title">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <div class="custom-label">{{ $static('ceo.t2', 'Мета-тег description') }}</div>
                  <textarea class="form-control custom-input" v-model="selected.info.description"></textarea>
                </div>
              </div>
            </div>

          </div>
          <div class="panel-bottom">
            <button class="transparent-btn default-btn back_trigger" @click="cancel">
              <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
            </button>
            <button class=" default-btn btn-accent" @click="save">
              <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
            </button>
            <!--            <button class="waves-effect waves-light default-btn btn-red">-->
            <!--              <span class="text">Видалити</span>-->
            <!--            </button>-->
          </div>
        </div>
      </div>
      <!--END EDITOR WRAPPER-->
    </Teleport>

  </div>
</template>

<script>
import api from '@/api'
import LangSelector from '../components/LangSelector';
import CategoriesRow from './CategoriesRow';

let converter = {
  'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
  'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
  'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
  'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
  'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch',
  'ш': 'sh', 'щ': 'sch', 'ь': '', 'ы': 'y', 'ъ': '',
  'э': 'e', 'ю': 'yu', 'я': 'ya',

  'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D',
  'Е': 'E', 'Ё': 'E', 'Ж': 'Zh', 'З': 'Z', 'И': 'I', 'І': 'I', 'і': 'i',
  'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
  'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T',
  'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C', 'Ч': 'Ch',
  'Ш': 'Sh', 'Щ': 'Sch', 'Ь': '', 'Ы': 'Y', 'Ъ': '', ' ': '-', '/': '-',
  'Э': 'E', 'Ю': 'Yu', 'Я': 'Ya'
};

export default {
  name: 'Categories',
  components: { LangSelector, CategoriesRow },
  data() {
    return {
      category: [],
      settings: [],
      load: false,
      lang: '',
      errors: {},
      selected: undefined
    }
  },
  computed: {
    langs() {
      return this.$store.getters.settings
        && this.$store.getters.settings.public
        && this.$store.getters.settings.public.lang
        && Array.isArray(this.$store.getters.settings.public.lang) ?
        this.$store.getters.settings.public.lang : []
    },
    optionsTags() {
      return this.$store.getters.options.filter(i => i.option_id === 'tags')
    },
    list() {
      return this.category && this.category.list ? this.category.list.sort((a, b) => a.order - b.order) : []
    },
    urlTranslite() {
      let x = this.translit(this.selected.name);
      return x ? x.toLowerCase() : x
    },
    basicLang() {
      return this.lang === ''
    },
    translate: {
      get() {
        return this.lang && this.selected && this.selected.translate && this.selected.translate[this.lang] ? this.selected.translate[this.lang] : {}
      },
      set(value) {
      }
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    selectOption(key, value) {
      if (!this.selected.info) {
        this.selected.info = {};
      }
      if (!this.selected.info.tags || !Array.isArray(this.selected.info.tags)) {
        this.selected.info.tags = [];
      }
      let target = this.selected.info;
      try {
        let idx = target[key].indexOf(value);
        if (idx === -1) {
          target[key].push(value)
        } else {
          target[key].splice(idx, 1)
        }
      } catch (e) {
        target[key] = [value];
      }
    },
    selectedOption(key, value) {
      let target = this.selected.info;
      if (!Array.isArray(target[key])) {
        return -1
      }
      return target && target[key] ? target[key].indexOf(value) : -1
    },
    translit(word) {
      if (!word) {
        return word
      }
      let answer = '';
      for (var i = 0; i < word.length; ++i) {
        if (converter[word[i]] === undefined) {
          answer += word[i];
        } else {
          answer += converter[word[i]];
        }
      }
      return answer;
    },
    setTranslate(key, value) {
      if (!this.selected.translate || Array.isArray(this.selected.translate)) {
        this.selected.translate = {}
      }
      if (!this.selected.translate[this.lang]) {
        this.selected.translate[this.lang] = {}
      }
      this.selected.translate[this.lang][key] = value
    },
    delImage() {
      this.selected.image = null;
    },
    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select)
    },
    select() {
      // const base = this.$store.getters['fm/settings/baseUrl'];
      this.selected.image = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path)).map(
        i => { return { url: i } }).slice(0, 1)[0].url;
    },
    swap(index1, index2) {
      if (index2 > this.category.list.length - 1 || index2 < 0) {
        return
      }
      let list = [...this.category.list];
      list[index1].order = index2;
      list[index2].order = index1;
      api.post('/api/options', { list: [list[index1], list[index2]] }).then(() => {
        this.getItems()
      })
    },
    getItems() {
      api.get('/api/options').then(response => response.data).then(data => {
        this.$store.commit('setOptions', data)
      });

      api.get('/api/options/categories')
        .then(response => response.data)
        .then(data => {
          if (data.result) {
            this.category = data.result.find(i => i.option_id === 'category')
          }
          if (data.settings) {
            this.settings = data.settings
          }
        })
    },
    removeItem(item, event) {
      window.$('#confirm-modal').modal('show');
      window.onModalConfirm = () => {
        api.delete(`/api/options/${item.id}`);
        let idx = this.category.list.findIndex(i => i.id === item.id);
        if (idx > -1) {
          this.category.list[idx].deleted = true
        }
      }
    },
    validate() {
      if (!this.selected.name || this.selected.name.length < 1) {
        this.errors.name = [
          this.$static(
            'cat.name-required',
            'Имя категории обовьязкове'
          )
        ];

        this.$notify({
          title: 'URL',
          type: 'error',
          text: this.errors.name.join('\n'),
          duration: 10000
        });
        return false
      }
      if (!this.selected.info.url) {
        this.selected.info.url = this.urlTranslite.trim()
      }
      this.selected.info.url = this.selected.info.url.trim()
      console.log(this.selected.info.url)
      let check = /[a-zA-Z\-\d]*/.exec(this.selected.info.url);
      if (!check[0] || check[0] !== check.input) {
        this.errors.url = [
          this.$static(
            'cat.url-invalidd',
            'Доступні лише анлійскі символи та знак "-"'
          )
        ];

        this.$notify({
          title: 'URL',
          type: 'error',
          text: this.errors.url.join('\n'),
          duration: 10000
        });
        return false
      }
      return true
    },
    save() {
      if (this.load) {
        return
      }
      if (!this.selected.info.url || this.selected.info.url.length < 1) {
        let v1 = this.translit(this.selected.name).toLowerCase();
        if (v1) {
          this.selected.info.url = v1
        } else {
          this.selected.info.url = 'c' + (Math.random() * 10000 | 0)
        }
      }
      if (!this.validate()) {
        return;
      }
      this.load = true;
      if (this.selected.id !== undefined) {
        api.put('/api/options', this.selected).then(response => response.data).then(data => {
          this.load = false;
          let idx = this.category.list.findIndex(i => i.id === data.id);
          if (idx > -1) {
            this.category.list[idx] = Object.assign(this.category.list[idx], data)
          }
          this.$notify({
            title: this.$static('notify-сategory.title', 'Категорії'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 3000
          });
          this.cancel();
        })
      } else {
        api.post('/api/options', { list: [this.selected] }).then(() => {
          this.$notify({
            title: this.$static('notify-сategory.title', 'Категорії'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 3000
          });
          this.load = false;
          this.getItems();
          this.cancel();
        })
      }
    },
    cancel() {
      this.selected = undefined;
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    openEditor(item, event) {
      if (!item.info) {
        item.info = {}
      }
      this.selected = Object.assign({}, item);
      if (Array.isArray(this.selected.info)) {
        this.selected.info = {}
      }
      // this.selected = item;
      // window.$(event.target).toggleClass('open');
      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');

      window.$('.back-blur').toggleClass('active');
      window.$('.overlay-editor.item-editor').toggleClass('active');
    },
    addNew() {
      let order = 0;
      if (this.category) {
        let order = Math.max(...this.category.list.map(i => i.order));
      }
      this.selected = { info: {}, translate: {}, disabled: 1, option: 'Категория', option_id: 'category', order: order + 1 };
      // this.selected = item;
      // window.$(event.target).toggleClass('open');
      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');

      window.$('.back-blur').toggleClass('active');
      window.$('.overlay-editor.item-editor').toggleClass('active');
    }
  },
  watch: {}
}
</script>
